module.exports = __webpack_public_path__ + "static/media/bootcamps_home.cfe2dad0.png";